/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as jQuery from 'jquery';

export class DefinitionApiClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";
    }

    allDefinitions() {
        return new Promise<DefinitionsViewModel>((resolve, reject) => {
            this.allDefinitionsWithCallbacks((result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private allDefinitionsWithCallbacks(onSuccess?: (result: DefinitionsViewModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/DefinitionApi/allDefs";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processAllDefinitionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAllDefinitionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAllDefinitionsWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAllDefinitions(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAllDefinitions(xhr: any): DefinitionsViewModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <DefinitionsViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    cmsModules() {
        return new Promise<CmsModuleDefinition[]>((resolve, reject) => {
            this.cmsModulesWithCallbacks((result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private cmsModulesWithCallbacks(onSuccess?: (result: CmsModuleDefinition[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/DefinitionApi/cmsModules";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processCmsModulesWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCmsModulesWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCmsModulesWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCmsModules(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCmsModules(xhr: any): CmsModuleDefinition[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsModuleDefinition[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    usefulJsonSchemas() {
        return new Promise<any | null>((resolve, reject) => {
            this.usefulJsonSchemasWithCallbacks((result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private usefulJsonSchemasWithCallbacks(onSuccess?: (result: any | null) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/DefinitionApi/usefulJsonSchemas";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/octet-stream"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processUsefulJsonSchemasWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUsefulJsonSchemasWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUsefulJsonSchemasWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUsefulJsonSchemas(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUsefulJsonSchemas(xhr: any): any | null | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    jsonSchemaForType(assemblyQualifiedName: string | null | undefined) {
        return new Promise<any | null>((resolve, reject) => {
            this.jsonSchemaForTypeWithCallbacks(assemblyQualifiedName, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private jsonSchemaForTypeWithCallbacks(assemblyQualifiedName: string | null | undefined, onSuccess?: (result: any | null) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/DefinitionApi/jsonSchemaForType?";
        if (assemblyQualifiedName !== undefined && assemblyQualifiedName !== null)
            url_ += "assemblyQualifiedName=" + encodeURIComponent("" + assemblyQualifiedName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/octet-stream"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processJsonSchemaForTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processJsonSchemaForTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processJsonSchemaForTypeWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processJsonSchemaForType(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processJsonSchemaForType(xhr: any): any | null | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class StaticClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";
    }

    templateSettingSchemaJson(templateId: string | null) {
        return new Promise<any | null>((resolve, reject) => {
            this.templateSettingSchemaJsonWithCallbacks(templateId, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private templateSettingSchemaJsonWithCallbacks(templateId: string | null, onSuccess?: (result: any | null) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/TemplateSettingSchema/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/octet-stream"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processTemplateSettingSchemaJsonWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTemplateSettingSchemaJsonWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processTemplateSettingSchemaJsonWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTemplateSettingSchemaJson(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTemplateSettingSchemaJson(xhr: any): any | null | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200 || status === 206) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class WeatherForecastClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";
    }

    get() {
        return new Promise<WeatherForecast[]>((resolve, reject) => {
            this.getWithCallbacks((result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getWithCallbacks(onSuccess?: (result: WeatherForecast[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): WeatherForecast[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <WeatherForecast[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class CmsApiClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";
    }

    allTemplates(deprecated: boolean | null | undefined) {
        return new Promise<TemplateInformation[]>((resolve, reject) => {
            this.allTemplatesWithCallbacks(deprecated, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private allTemplatesWithCallbacks(deprecated: boolean | null | undefined, onSuccess?: (result: TemplateInformation[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/allTemplates?";
        if (deprecated !== undefined && deprecated !== null)
            url_ += "deprecated=" + encodeURIComponent("" + deprecated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processAllTemplatesWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAllTemplatesWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAllTemplatesWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAllTemplates(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAllTemplates(xhr: any): TemplateInformation[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <TemplateInformation[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    analysisPhoneNumber(model: EncryptionInputModel) {
        return new Promise<string>((resolve, reject) => {
            this.analysisPhoneNumberWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private analysisPhoneNumberWithCallbacks(model: EncryptionInputModel, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/analysisPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processAnalysisPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAnalysisPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAnalysisPhoneNumberWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAnalysisPhoneNumber(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAnalysisPhoneNumber(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getAllTemplateVersionUIDs() {
        return new Promise<CmsSettingVersionUIDModel[]>((resolve, reject) => {
            this.getAllTemplateVersionUIDsWithCallbacks((result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getAllTemplateVersionUIDsWithCallbacks(onSuccess?: (result: CmsSettingVersionUIDModel[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/allTemplateVersionUIDs";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetAllTemplateVersionUIDsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllTemplateVersionUIDsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllTemplateVersionUIDsWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllTemplateVersionUIDs(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllTemplateVersionUIDs(xhr: any): CmsSettingVersionUIDModel[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingVersionUIDModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getTemplateInfo(templateId: string | null | undefined) {
        return new Promise<TemplateInformation>((resolve, reject) => {
            this.getTemplateInfoWithCallbacks(templateId, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getTemplateInfoWithCallbacks(templateId: string | null | undefined, onSuccess?: (result: TemplateInformation) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/templateInfo?";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetTemplateInfoWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetTemplateInfoWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetTemplateInfoWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetTemplateInfo(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetTemplateInfo(xhr: any): TemplateInformation | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <TemplateInformation>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getDefaultCmsSettingJson(templateId: string | null | undefined) {
        return new Promise<string>((resolve, reject) => {
            this.getDefaultCmsSettingJsonWithCallbacks(templateId, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getDefaultCmsSettingJsonWithCallbacks(templateId: string | null | undefined, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/defaultCmsSettingJson?";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetDefaultCmsSettingJsonWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDefaultCmsSettingJsonWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDefaultCmsSettingJsonWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDefaultCmsSettingJson(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDefaultCmsSettingJson(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getTemplateCapabilities(model: CmsSettingModel) {
        return new Promise<AllTemplateCapabilityViewModel>((resolve, reject) => {
            this.getTemplateCapabilitiesWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getTemplateCapabilitiesWithCallbacks(model: CmsSettingModel, onSuccess?: (result: AllTemplateCapabilityViewModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/templateCapabilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetTemplateCapabilitiesWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetTemplateCapabilitiesWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetTemplateCapabilitiesWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetTemplateCapabilities(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetTemplateCapabilities(xhr: any): AllTemplateCapabilityViewModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <AllTemplateCapabilityViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    checkArticleTypeUsed(model: CheckArticleTypeModel) {
        return new Promise<boolean>((resolve, reject) => {
            this.checkArticleTypeUsedWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private checkArticleTypeUsedWithCallbacks(model: CheckArticleTypeModel, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_checkArticleTypeUsed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processCheckArticleTypeUsedWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckArticleTypeUsedWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckArticleTypeUsedWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckArticleTypeUsed(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckArticleTypeUsed(xhr: any): boolean | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    checkCategoryUsed(model: CheckCategoryUsedModel) {
        return new Promise<boolean>((resolve, reject) => {
            this.checkCategoryUsedWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private checkCategoryUsedWithCallbacks(model: CheckCategoryUsedModel, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_checkCategoryUsed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processCheckCategoryUsedWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckCategoryUsedWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckCategoryUsedWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckCategoryUsed(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckCategoryUsed(xhr: any): boolean | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    normalizeCmsSetting(model: CmsSettingModel) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.normalizeCmsSettingWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private normalizeCmsSettingWithCallbacks(model: CmsSettingModel, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_normalizeCmsSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processNormalizeCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processNormalizeCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processNormalizeCmsSettingWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processNormalizeCmsSetting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processNormalizeCmsSetting(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    changeTemplate(model: ChangeTemplateModel) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.changeTemplateWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private changeTemplateWithCallbacks(model: ChangeTemplateModel, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_changeTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processChangeTemplateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processChangeTemplateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processChangeTemplateWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processChangeTemplate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processChangeTemplate(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    updateCmsSetting(model: CmsSettingModel) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.updateCmsSettingWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private updateCmsSettingWithCallbacks(model: CmsSettingModel, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_updateCmsSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processUpdateCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateCmsSettingWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateCmsSetting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateCmsSetting(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    migrateCmsSetting(model: CmsSettingModel) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.migrateCmsSettingWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private migrateCmsSettingWithCallbacks(model: CmsSettingModel, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_migrateCmsSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processMigrateCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMigrateCmsSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processMigrateCmsSettingWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMigrateCmsSetting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMigrateCmsSetting(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    updateRecommendProducts(model: CmsSettingModel, productIds: number[] | null | undefined) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.updateRecommendProductsWithCallbacks(model, productIds, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private updateRecommendProductsWithCallbacks(model: CmsSettingModel, productIds: number[] | null | undefined, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_updateRecommendProducts?";
        if (productIds !== undefined && productIds !== null)
            productIds && productIds.forEach(item => { url_ += "productIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processUpdateRecommendProductsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateRecommendProductsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateRecommendProductsWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateRecommendProducts(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateRecommendProducts(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getCompanyWapBanners(model: CmsSettingModel) {
        return new Promise<CmsLinkViewModel[]>((resolve, reject) => {
            this.getCompanyWapBannersWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getCompanyWapBannersWithCallbacks(model: CmsSettingModel, onSuccess?: (result: CmsLinkViewModel[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_getCompanyWapBanners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetCompanyWapBannersWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetCompanyWapBannersWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetCompanyWapBannersWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetCompanyWapBanners(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetCompanyWapBanners(xhr: any): CmsLinkViewModel[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsLinkViewModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getCompanyWapAdverts(model: CmsSettingModel) {
        return new Promise<CmsLinkViewModel[]>((resolve, reject) => {
            this.getCompanyWapAdvertsWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getCompanyWapAdvertsWithCallbacks(model: CmsSettingModel, onSuccess?: (result: CmsLinkViewModel[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_getCompanyWapAdverts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetCompanyWapAdvertsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetCompanyWapAdvertsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetCompanyWapAdvertsWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetCompanyWapAdverts(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetCompanyWapAdverts(xhr: any): CmsLinkViewModel[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsLinkViewModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getRecommandProductIds(model: CmsSettingModel) {
        return new Promise<number[]>((resolve, reject) => {
            this.getRecommandProductIdsWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getRecommandProductIdsWithCallbacks(model: CmsSettingModel, onSuccess?: (result: number[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_getRecommendedProductIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetRecommandProductIdsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRecommandProductIdsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRecommandProductIdsWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRecommandProductIds(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRecommandProductIds(xhr: any): number[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    getCompanyWapBackground(model: CmsSettingModel) {
        return new Promise<string>((resolve, reject) => {
            this.getCompanyWapBackgroundWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private getCompanyWapBackgroundWithCallbacks(model: CmsSettingModel, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_getCompanyWapBackground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processGetCompanyWapBackgroundWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetCompanyWapBackgroundWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetCompanyWapBackgroundWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetCompanyWapBackground(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetCompanyWapBackground(xhr: any): string | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    updateCmsBanners(model: CmsSettingUpdateBannerModel) {
        return new Promise<CmsSettingModel>((resolve, reject) => {
            this.updateCmsBannersWithCallbacks(model, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private updateCmsBannersWithCallbacks(model: CmsSettingUpdateBannerModel, onSuccess?: (result: CmsSettingModel) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/_updateBanners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processUpdateCmsBannersWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateCmsBannersWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateCmsBannersWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateCmsBanners(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateCmsBanners(xhr: any): CmsSettingModel | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }

    checkMigratabilities(settings: CmsSettingModel[]) {
        return new Promise<CmsSettingMigratabilityResult[]>((resolve, reject) => {
            this.checkMigratabilitiesWithCallbacks(settings, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private checkMigratabilitiesWithCallbacks(settings: CmsSettingModel[], onSuccess?: (result: CmsSettingMigratabilityResult[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/CmsApi/migratabilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processCheckMigratabilitiesWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckMigratabilitiesWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckMigratabilitiesWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckMigratabilities(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckMigratabilities(xhr: any): CmsSettingMigratabilityResult[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <CmsSettingMigratabilityResult[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export class ProductApiClient {
    baseUrl: string;
    beforeSend: any = undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5002";
    }

    autocomplete(companyId: number | undefined, q: string | null | undefined) {
        return new Promise<AutocompletionViewModel[]>((resolve, reject) => {
            this.autocompleteWithCallbacks(companyId, q, (result) => resolve(result), (exception, _reason) => reject(exception));
        });
    }

    private autocompleteWithCallbacks(companyId: number | undefined, q: string | null | undefined, onSuccess?: (result: AutocompletionViewModel[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ProductApi/autocomplete?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            dataType: "text",
            headers: {
                "Accept": "application/json"
            }
        }).done((_data, _textStatus, xhr) => {
            this.processAutocompleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAutocompleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAutocompleteWithCallbacks(_url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAutocomplete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAutocomplete(xhr: any): AutocompletionViewModel[] | null {
        const status = xhr.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = xhr.responseText;
            let result200: any = null;
            result200 = _responseText === "" ? null : <AutocompletionViewModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return null;
    }
}

export interface DefinitionsViewModel {
    CmsGlobal?: FhtCmsGlobal | undefined;
    SearchType: SearchType;
    KnownCmsPageType: KnownCmsPageType;
    CmsPresetPage: CmsPresetPage;
}

export interface FhtCmsGlobal {
    Env: FhtCommonEnv;
    Cms: FhtCmsEnv;
    KnownPage?: KnownCmsPageType | undefined;
}

export interface FhtCommonEnv {
    AppEnv?: ApplicationEnvEnum | undefined;
    AppVersion: string;
    DEBUG: number;
    IsRelease: boolean;
    Hosts: WebHosts;
}

export enum ApplicationEnvEnum {
    Local = "Local",
    Development = "Development",
    MobileDevelopment = "MobileDevelopment",
    Staging = "Staging",
    Production = "Production",
}

export interface WebHosts {
    FhtWebTopicRoot: string;
    FhtWebDetailRoot: string;
    FhtWebCompanyRoot: string;
    FhtWebMobileCompanyRoot: string;
    FhtWebUrlRoot: string;
    FhtWebMobileUrlRoot: string;
    FhtApiRoot: string;
}

export interface FhtCmsEnv {
    CompanyId: number;
    IsCustomDomain: boolean;
    IsPreviewing: boolean;
    IsOnPremises: boolean;
}

export enum KnownCmsPageType {
    CmsHome = "CmsHome",
    CmsProductList = "CmsProductList",
    CmsArticleList = "CmsArticleList",
    CmsProductDetail = "CmsProductDetail",
    CmsArticleDetail = "CmsArticleDetail",
    CmsAboutUs = "CmsAboutUs",
    CmsContactUs = "CmsContactUs",
    ProductSearch = "ProductSearch",
    TopicPostSearch = "TopicPostSearch",
    UserSearch = "UserSearch",
    CompanySearch = "CompanySearch",
}

export enum SearchType {
    Product = "Product",
    TopicPost = "TopicPost",
    Company = "Company",
    User = "User",
}

export enum CmsPresetPage {
    Home = "Home",
    Products = "Products",
    News = "News",
    AboutUs = "AboutUs",
    ContactUs = "ContactUs",
    Case = "Case",
    Honor = "Honor",
    Album = "Album",
}

export interface CmsModuleDefinition {
    Type?: string | undefined;
    Properties?: CmsModulePropertyDefinition[] | undefined;
}

export interface CmsModulePropertyDefinition {
    Name?: string | undefined;
}

export interface WeatherForecast {
    Date: Date;
    TemperatureC: number;
    TemperatureF: number;
    Summary?: string | undefined;
}

export interface TemplateInformation {
    Config?: TemplateConfig | undefined;
    TemplateId?: string | undefined;
    SelfHasTemplateSetting: boolean;
}

export interface TemplateConfig {
    Title: string;
    Version: number;
    IsAbstract: boolean;
    Author: string;
    Inherit?: string | undefined;
    FallbackMobileTemplateId?: string | undefined;
    TemplatePreviewUrl?: string | undefined;
    Order: number;
    Deprecated?: boolean | undefined;
    IsAdvanced: boolean;
    Multilingual?: boolean | undefined;
    TemplateType?: TemplateDesignType | undefined;
    SuitableIndustries?: TemplateSuitableIndustry[] | undefined;
    CoverImageUrl?: string | undefined;
    MobileCoverImageUrl?: string | undefined;
}

export enum TemplateDesignType {
    Responsive = "Responsive",
    WebOnly = "WebOnly",
    WebAndSeparateMobile = "WebAndSeparateMobile",
}

export enum TemplateSuitableIndustry {
    Hardware = "Hardware",
    Mechanics = "Mechanics",
    Chemical = "Chemical",
    Furniture = "Furniture",
    Textile = "Textile",
    Security = "Security",
    Business = "Business",
    Digital = "Digital",
    Store = "Store",
    Printing = "Printing",
    MedicalCare = "MedicalCare",
    Agriculture = "Agriculture",
    Electronics = "Electronics",
    Trappings = "Trappings",
    Vehicle = "Vehicle",
    Outdoors = "Outdoors",
}

export interface EncryptionInputModel {
    EncryptionText: string;
}

export interface CmsSettingVersionUIDModel {
    TemplateId?: string | undefined;
    VersionUID?: string | undefined;
}

export interface AllTemplateCapabilityViewModel {
    ProductListStyle: ArticleListStyle;
    ProductPageSize: number;
    ArticlePageSize: number;
    Banners?: BannerItem[] | undefined;
    WapBackground?: string | undefined;
    WapBanners?: BannerItem[] | undefined;
    WapAdverts?: BannerItem[] | undefined;
    CssjsContent?: CssjsContent | undefined;
    AllLinkItems?: LinkItem[] | undefined;
    RecommendedProductIds?: number[] | undefined;
    ArticleListStyles?: { [key: string]: ArticleListStyle; } | undefined;
}

export enum ArticleListStyle {
    Text = "Text",
    Image = "Image",
    Mix = "Mix",
}

export interface BannerItem {
    ImageUrl?: string | undefined;
    Link?: LinkItem | undefined;
}

export interface LinkItem {
    LinkType: LinkType;
    LinkItemId?: number | undefined;
}

export enum LinkType {
    None = "None",
    Product = "Product",
    ArticleType = "ArticleType",
    Article = "Article",
    CustomCategory = "CustomCategory",
}

export interface CssjsContent {
    Css?: string | undefined;
    Js?: string | undefined;
}

export interface CmsSettingModel {
    TemplateId: string;
    VersionUID?: string | undefined;
    SettingJson?: string | undefined;
}

export interface CheckArticleTypeModel {
    TemplateId: string;
    ArticleTypeId: number;
    SettingJson?: string | undefined;
}

export interface CheckCategoryUsedModel {
    TemplateId: string;
    CategoryId: number;
    SettingJson?: string | undefined;
}

export interface ChangeTemplateModel {
    Old?: CmsSettingModel | undefined;
    New?: CmsSettingModel | undefined;
}

export interface CmsLinkViewModel {
    ImageUrl?: string | undefined;
    Link2Item?: CmsApiLink2Item | undefined;
}

export interface CmsApiLink2Item {
    LinkType: LinkType;
    Link2ItemId?: number | undefined;
}

export interface CmsSettingUpdateBannerModel extends CmsSettingModel {
    Banners?: BannerItem[] | undefined;
}

export interface CmsSettingMigratabilityResult {
    TemplateIdNotFound: boolean;
    LatestTemplateUID?: string | undefined;
    IsMigratable: boolean;
    UpToDate: boolean;
    FailToSerializeMessage?: string | undefined;
    SettingJsonAndTemplateUIDMismatchWarningMessage?: string | undefined;
    TemplateCapabilities?: AllTemplateCapabilityViewModel | undefined;
}

export interface AutocompletionViewModel {
    Value: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}